import { render, staticRenderFns } from "./Related.vue?vue&type=template&id=6fe0ee86&scoped=true&"
import script from "./Related.vue?vue&type=script&lang=js&"
export * from "./Related.vue?vue&type=script&lang=js&"
import style0 from "./Related.vue?vue&type=style&index=0&id=6fe0ee86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe0ee86",
  null
  
)

export default component.exports